import styled from 'styled-components'

export const CheckboxSwitchControl = styled.label`
  position: relative;
  display: block;
  width: 40px;
  height: 24px;
  border-radius: ${({ theme: { layout } }) => layout.spacing(3)};
  background-color: ${({ theme: { colors } }) => colors.backgroundInactive};
  transition: background-color 0.3s;
  cursor: pointer;

  &::before {
    content: '';
    position: absolute;
    top: 2px;
    left: 2px;
    width: 20px;
    height: 20px;
    border: none;
    border-radius: 50%;
    background: ${({ theme: { colors } }) => colors.backgroundContent};
    transition: transform 0.18s cubic-bezier(0, 0, 0, 1);
    cursor: pointer;
  }
`
export const CheckboxSwitchInput = styled.input`
  display: none;

  &:checked + label {
    background: ${({ theme: { colors } }) => colors.success};

    &::before {
      transform: translateX(16px);
    }
  }

  &:disabled + label {
    background-color: ${({ theme: { colors } }) => colors.disabled};
  }
`
export const CheckboxSwitchWrapper = styled.div`
  display: inline-block;
  margin: 0;
`
